<template>
    <main-layout id="new-installation-page">

        <app-header icon="tools">
            Ajout installation
        </app-header>

        <action-bar :back="{name: 'liste-installations', params: {id: this.$route.params.id}}">
        </action-bar>

        <form id="installation" class="wrap" @submit.prevent="sendForm">

            <label>Cette installation contient-elle du fluide frigorigène ?</label>
            <div class="radio">
                <input name="showF" id="showF_ok" type="radio" :value="true" v-model="showFluideSection" @change="choiceDone()">
                <label for="showF_ok" class="custom-radio">
                    Oui
                    <i class="icon-valid"></i>
                </label>
            </div>
            <div class="radio">
                <input name="showF" id="showF_ko" type="radio" :value="false" v-model="showFluideSection" @change="choiceDone()">
                <label for="showF_ko" class="custom-radio">
                    Non
                    <i class="icon-valid"></i>
                </label>
            </div>

            <div class="clear"></div>

            <div v-show="typeChoosed">

                <!-- PHOTO OCR ONLY FOR USER ID 2600 -->
                <div v-if="this.navigatorOnline && this.$user && this.$user.id === 2600">
                    <a href="javascript: void 0" class="btn btn-full photo" @click="$refs.photoOCR.click()">
                        Remplissage automatique par photo
                        <i class="icon-photo"></i>
                    </a>
                    <input type="file" ref="photoOCR" v-show="false" @change="handlePhotoOCR">
                </div>

                <!-- PHOTO OCR ONLY FOR USER ID 2600 -->
                <div v-else-if="!this.navigatorOnline && this.$user && this.$user.id === 2600">
                    <a href="javascript: void 0" class="btn btn-full photo" style="background-color: darkgray">
                        Remplissage automatique impossible hors ligne
                        <i class="icon-photo"></i>
                    </a>
                </div>



                <label v-if="this.$route.query.itag">Otag install</label>
                <input v-if="this.$route.query.itag" title="itag" type="text" name="i_tag" v-model.trim="installation.i_tag" readonly >

                <label>Nom de l'installation *</label>
                <div style="display: flex;">
                    <input title="installName" type="text" name="nom" id="nom" maxlength="255" value="" v-model.trim="installation.nom">
                    <a v-if="optionBarcode === true" href="fi360://scan?success=fillCodeBarre&type=installation" class="btn btn-full" id="barcode-scan" style="margin-left: 5px"><img src="../../img/barcode-scan.png" style="padding: 0 20px; height: 35px"> </a>
                </div>

                <label>Marque <span v-show="showFluideSection === false">*</span></label>
                <input title="marque" type="text" name="nom" id="marque" maxlength="255" value="" v-model.trim="installation.marque">

                <label>Modèle / N° de série / Repère <span v-show="showFluideSection === false">*</span></label>
                <input title="model" type="text" name="nom" id="modele" maxlength="255" value="" v-model.trim="installation.modele">

                <label>Commentaire</label>
                <input title="commentaire" type="text" name="commentaire" id="commentaire" maxlength="255" value="" v-model.trim="installation.commentaire">

                <div v-for="slot in photoSlots" :key="slot.field">
                    <a href="javascript: void 0" class="btn btn-full photo" @click="$refs['photo_' + slot.field][0].click()">
                        {{ slot.label }}
                        <i class="icon-photo"></i>
                    </a>
                    <input type="file" :ref="'photo_' + slot.field" v-show="false" @change="handlePhotoInstall($event, slot.field)">
                    <div class="preview-img" v-if="installation[slot.field]">
                        <i class="icon icon-delete" @click="dropPhoto(slot.field)"></i>
                        <img :src="installation[slot.field]" alt="photo installation" class="photo-install">
                    </div>
                </div>

            </div>

            <div v-show="showFluideSection">

                <label>Type de fluide *</label>
                <select ref="fluide" title="fluid" v-model="installation.fluide"
                        @change="updateComputed">
                    <option disabled selected>Sélectionnez un fluide</option>
                    <option v-for="fluide in fluides" :key="fluide && fluide.id" :value="fluide" v-if="fluide && fluide.nom !== 'R-999'">
                        {{ fluide.nom }}
                        {{(fluide.nom_commercial) ? ' - ' + fluide.nom_commercial : ''}}
                    </option>
                </select>

                <label>Charge totale (Kg) *</label>
                <input title="chargeTotal" type="number" ref="charge" step="0.001" min="0.010" v-model.number="installation.charge" inputmode="decimal" @change="updateComputed">

                <label>Détecteur de fuite fixe *</label>
                <div class="radio">
                    <input name="detecteur_fuite_fixe" ref="detec" id="fuite_ok" type="radio" :value="true"
                           v-model="installation.detecteur" @change="updateComputed">
                    <label for="fuite_ok" class="custom-radio">
                        Oui
                        <i class="icon-valid"></i>
                    </label>
                </div>
                <div class="radio">
                    <input name="detecteur_fuite_fixe" ref="detec2" id="fuite_ko" type="radio" :value="false"
                           v-model="installation.detecteur" @change="updateComputed">
                    <label for="fuite_ko" class="custom-radio">
                        Non
                        <i class="icon-valid"></i>
                    </label>
                </div>

                <div class="clear"></div>


                <div v-if="canForceFrequence === true">
                    <label>Fréquence de contrôle forcée</label>
                    <div class="radio">
                        <input name="force_frequence" id="force_frequence" type="radio" :value="true"
                               v-model="installation.force_frequence" @change="updateComputed">
                        <label for="force_frequence" class="custom-radio">
                            Oui
                            <i class="icon-valid"></i>
                        </label>
                    </div>

                    <div class="radio">
                        <input name="force_frequence" id="force_frequence_no" type="radio" :value="false"
                               v-model="installation.force_frequence" @change="updateComputed">
                        <label for="force_frequence_no" class="custom-radio">
                            Non
                            <i class="icon-valid"></i>
                        </label>
                    </div>
                </div>

                <div class="clear"></div>

                <div v-if="installation.force_frequence === true">
                    <label>Fréquence de contrôle</label>
                    <select name="frequence_controle" id="frequence_controle" v-model="installation.frequence_controle">
                        <option value="3">3 mois</option>
                        <option value="6">6 mois</option>
                        <option value="12">12 mois</option>
                        <option value="24">24 mois</option>
                    </select>
                </div>

                <input type="hidden" v-model.number="installation.tonnage">

                <input type="hidden" v-model.number="installation.frequence_controle">

                <div style="display: inline-block; width: 100%">
                    <p v-if="installation.fluide && installation.fluide.type && installation.fluide.type !== 'HFO'">
                        Tonnage équivalent CO<span class="smallexp">2</span> :
                        <span id="tonnage" v-text="installation.tonnage"></span>
                    </p>

                    <p v-if="installation.fluide && installation.fluide.gwp">
                        GWP :
                        <span id="gwp" v-text="installation.fluide.gwp"></span>
                    </p>

                    <p v-if="installation.fluide && installation.fluide.type !== 'CFC' && installation.detecteur !== null">
                        Fréquence de contrôle de l'installation :
                        <span id="frequence">{{ installation.frequence_controle === 0 || installation.frequence_controle == null ? 'Aucune' : installation.frequence_controle + ' Mois' }}</span>
                    </p>
                </div>

            </div>



            <div class="clear"></div>

            <div v-show="typeChoosed">
                <input type="submit" id="submit-install" name="new" value="AJOUTER" :disabled="saving">
            </div>

        </form>

    </main-layout>
</template>

<script>
import Installation from '../../js/models/Installation'
import Fluide from '../../js/models/Fluide'
import Synchro from '../../js/core/Synchro'

import loadImage from 'blueimp-load-image'
import localforage from "localforage";
import Operateur from "@/js/models/Operateur";

export default {

        data() {
            return {
                installation: {
                    nom: null,
                    marque: null,
                    modele: null,
                    commentaire: null,
                    photo: null,
                    photo2: null,
                    photo3: null,
                    fluide: {},
                    charge: null,
                    detecteur: null,
                    tonnage: null,
                    frequence_controle: null,
                    i_tag: null,
                },
                photoSlots: [
                    {field: 'photo', label: 'PHOTO INSTALLATION 1'},
                    {field: 'photo2', label: 'PHOTO INSTALLATION 2'},
                    {field: 'photo3', label: 'PHOTO INSTALLATION 3'},
                ],
                fluides: null,
                showFluideSection: null,
                typeChoosed: false,
                canForceFrequence: false,
                optionBarcode: false,
                saving: false,
                navigatorOnline: navigator.onLine
            }
        },

        methods: {

            choiceDone() {
                this.typeChoosed = true;
                if (false === this.showFluideSection) {
                    this.installation.fluide = {};
                    this.installation.charge = null;
                    this.installation.detecteur = null;
                    this.installation.tonnage = null;
                    this.installation.frequence_controle = null;
                }
            },

            sendForm() {
                if (this.saving) {
                    return;
                }

                if (this.showFluideSection !== null) {

                    let installation = this.installation;
                    let errors = [];

                    // CONDITION COMMUNE
                    if (!installation.nom) {
                        errors.push("le nom de l'installation")
                    }

                    if (this.showFluideSection === false) {

                        if (!installation.marque) {
                            errors.push("la marque")
                        }
                        if (!installation.modele) {
                            errors.push("le modèle")
                        }

                    } else if (this.showFluideSection === true) {

                        if (_.isEmpty(installation.fluide)) {
                            errors.push("le fluide")
                        }
                        if (!installation.charge) {
                            errors.push("la charge")
                        }
                        if (installation.detecteur === null) {
                            errors.push("le détecteur")
                        }

                    }

                    if (errors.length !== 0) {

                        let txt = errors.join(', ');
                        swal('Information(s) manquante(s) :', 'Veuillez renseigner ' + txt + '.', 'error')

                    } else {

                        this.saving = true;
                        Installation
                            .addInstallationOffline({data: {installation: Object.assign({}, this.installation)}, idDet: this.$route.params.id})
                            .then(tempId => {
                                const goList = () => this.$router.push({name: 'liste-installations', params: {id: this.$route.params.id} });
                                const aDesPhotos = this.photoSlots.some(slot => this.installation[slot.field]);

                                if (aDesPhotos && navigator.onLine) {
                                    // sweetalert2 6.x rejette la promesse sur « Plus tard », Échap ou clic extérieur
                                    swal({
                                        title: 'Installation ajoutée !',
                                        html: 'Vous avez créé une installation avec des photos, il est préférable de synchroniser.',
                                        type: 'success',
                                        showCancelButton: true,
                                        confirmButtonText: 'Synchroniser maintenant',
                                        cancelButtonText: 'Plus tard',
                                        allowOutsideClick: false
                                    }).then(() => {
                                        Synchro.definirRetourApresSynchro({idDet: this.$route.params.id, idInst: tempId});
                                        this.$router.push({name: 'synchro', query: {retour: 1}});
                                    }, goList);

                                    return;
                                }

                                swal({
                                    title: 'Installation ajoutée !',
                                    html: 'L\'installation a bien été ajoutée.',
                                    type: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false
                                }).then(goList, goList)
                            }, () => {
                                this.saving = false;
                                swal('Erreur', "L'installation n'a pas pu être enregistrée", 'error');
                            })

                    }

                } else {

                    swal('Formulaire incomplet', "Veuillez préciser si l'installation contient du fluide frigorigène", 'error')

                }

            },

            fetchFluides() {

                let vueInstance = this;

                localforage.getItem('listFluides')
                    .then(fluides => {
                        fluides = JSON.parse(fluides);
                        vueInstance.fluides = fluides.noFiltre.filter(f => !f.regenerated);
                    })
                    .catch()
            },

            handlePhotoInstall(e, field) {
                let vueInstance = this;
                let input = e.target;
                let file = input.files[0];

                if (!file) { return }

                // réinitialisé avant traitement : permet de re-sélectionner le même
                // fichier après suppression, y compris si loadImage échoue
                input.value = null;

                loadImage(
                    file,
                    function (img) {
                        if (img instanceof Event) {
                            swal('Erreur', 'Impossible de charger cette image, vérifiez le format du fichier.', 'error');
                            return;
                        }
                        vueInstance.$set(vueInstance.installation, field, img.toDataURL('image/jpeg', 0.82));
                    },
                    {
                        maxWidth: 700,
                        maxHeight: 700,
                        orientation: true,
                        canvas: true
                    }
                )

            },

            dropPhoto(field) {
                this.$set(this.installation, field, null);
            },

            handlePhotoOCR(e) {
                let vueInstance = this;

                let file = e.target.files[0];

                loadImage(
                    file,
                    function (img) {
                        if (img instanceof Event) {
                            vueInstance.$refs.photoOCR.value = null;
                            swal('Erreur', 'Impossible de charger cette image, vérifiez le format du fichier.', 'error');
                            return;
                        }
                        let photo64 = img.toDataURL();

                        Installation
                            .ocrPlate(photo64)
                            .then(data => {
                                vueInstance.$refs.photoOCR.value = null;
                                vueInstance.applyOcrData(data);
                            })
                            .catch(() => {
                                vueInstance.$refs.photoOCR.value = null;
                                swal('Erreur', 'La lecture automatique de la plaque a échoué, veuillez réessayer ou remplir manuellement.', 'error');
                            });
                    },
                    {
                        maxWidth: 1600,
                        maxHeight: 1600,
                        orientation: true,
                        canvas: true
                    }
                )
            },

            applyOcrData(data) {
                let vueInstance = this;

                if(data.nom_installation) {
                    vueInstance.installation.nom = data.nom_installation;
                }
                if(data.marque) {
                    vueInstance.installation.marque = data.marque;
                }
                let modele_full = '';
                if(data.modele) {
                    modele_full += data.modele;
                }
                if(data.numero_serie) {
                    modele_full += " / " + data.numero_serie;
                }
                if(data.repere) {
                    modele_full += " / " + data.repere;
                }

                if(modele_full !== '') {
                    vueInstance.installation.modele = modele_full;
                }

                if (data.fluide) {
                    const fluideRecherche = data.fluide.toLowerCase().replace(/-/g, '');
                    let found_fluide = vueInstance.fluides.find(f => {
                        const nom = f.nom ? f.nom.toLowerCase().replace(/-/g, '') : '';
                        const nomCommercial = f.nom_commercial ? f.nom_commercial.toLowerCase().replace(/-/g, '') : '';
                        return nom === fluideRecherche || nomCommercial === fluideRecherche;
                    });

                    if (found_fluide) {
                        vueInstance.installation.fluide = found_fluide;
                        vueInstance.updateComputed();
                    }
                }

                if(data.charge_kg) {
                    vueInstance.installation.charge = parseFloat(data.charge_kg);
                }
            },

            updateComputed() {

                if (_.has(this.installation.fluide, 'gwp') && this.installation.charge !== null) {
                    this.updateTonnage();

                    if (this.installation.detecteur !== null && this.installation.force_frequence !== true) {
                        this.updateFrequence()
                    }
                }
            },

            updateTonnage() {


                this.installation.tonnage = Fluide.calcTonnage(this.installation.fluide, this.installation.charge);

            },

            updateFrequence() {
                this.installation.frequence_controle = Installation.calcFrequence(
                    this.installation.detecteur,
                    this.installation.tonnage,
                    this.installation.charge,
                    this.installation.fluide
                );
            }
        },

        mounted: function () {
            this.fetchFluides();
            if(this.$route.query.itag != null) {
                this.installation.i_tag = this.$route.query.itag;
            }

            Operateur.getOperateurOption(options => {
                this.canForceFrequence = options.includes('force_install_frequence');
                this.optionBarcode = options.includes('scan_barcode_install');
            })



        },

    }

</script>



// WEBPACK FOOTER //
// NewInstallation.vue?27636e98